export class Native {
  static PLATFORM = 'ucoo_app_platform'
  static CHANNEL = 'ucoo_app_channel'
  static VERSION = 'ucoo_app_version'
  static TOAST = 'ucoo_toast'
  static FINISH = 'ucoo_finish'
  static TITLE = 'ucoo_title_bar'
  static IMMERSIVE = 'ucoo_immersive'
  static JUMP_TASK = 'jump'
  static STATUS_BAR = 'ucoo_status_bar_height'
  static NAVIGATION_BAR = 'ucoo_navigation_bar_height'
  static GO_TO_PUBLIC = 'go_to_public'
  static REQUEST_ANDROID_PERMISSION = 'ucoo_android_request_permission'
  static REQUEST_PERMISSION = 'ucoo_request_permission'
  static CACHE_ENABLE = 'ucoo_android_cache_enable'
  static UCOO_H5_JUMP_APP = 'ucoo_h5_jump_app'
  static UCOO_PAY = 'ucoo_fk'
  static RTM_CHANNEL = 'ucoo_rtm_channel'
  static WEB_VIDEO_EFFECT = 'ucoo_video_effect'
  static API_ERROR = 'ucoo_api_error'
  //copy
  static COPY = 'ucoo_copy'
}
